import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AppSignUpModalVariant } from "@faire/retailer-visitor-shared/components/AppSignUp/AppSignUpModalVariant";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useFaireDirectFirstOrderIncentive } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/useFaireDirectFirstOrderIncentive";
import { getTotalBrandCount } from "@faire/retailer-visitor-shared/lib/getMarketingCount";
import { useOpenWithFaireTerms } from "@faire/retailer-visitor-shared/stores/domain/OpenWithFaire/useOpenWithFaireTerms";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { formatMoney, RoundingStrategy } from "@faire/web--source/common/money";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import React from "react";
export var Subtitle = function(param) {
    var modalVariant = param.modalVariant, isOpenWithFaire = param.isOpenWithFaire, isFaireMarket = param.isFaireMarket, livestream = param.livestream, _param_align = param.align, align = _param_align === void 0 ? "center" : _param_align;
    var faireDirectBrand = useFaireDirectBrand().faireDirectBrand;
    var externalSalesRepName = getGlobalProperty("externalSalesRepName");
    var localeKey = getGlobalProperty("localeKey");
    var formattedPercentageBasedNumber = useFaireDirectFirstOrderIncentive().formattedPercentageBasedNumber;
    var offeredMaxTerms = useOpenWithFaireTerms().offeredMaxTerms;
    if (modalVariant === AppSignUpModalVariant.FAIRE_DIRECT) {
        var salesPersonName = externalSalesRepName;
        var brandCompanyName = faireDirectBrand === null || faireDirectBrand === void 0 ? void 0 : faireDirectBrand.name;
        return /*#__PURE__*/ _jsxs(Typography, {
            align: align,
            "data-test-id": "faire-direct-percentage-based-subtitle",
            children: [
                salesPersonName && brandCompanyName ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "xAJpl7",
                            defaultMessage: [
                                {
                                    type: 1,
                                    value: "salesPersonName"
                                },
                                {
                                    type: 0,
                                    value: " invited you to shop "
                                },
                                {
                                    type: 1,
                                    value: "brandCompanyName"
                                },
                                {
                                    type: 0,
                                    value: " on Faire."
                                }
                            ],
                            values: {
                                salesPersonName: salesPersonName,
                                brandCompanyName: brandCompanyName
                            }
                        }),
                        "\xa0"
                    ]
                }) : null,
                /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "BoKb3j",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Get "
                        },
                        {
                            type: 1,
                            value: "faireDirectPercentageDiscountNumber"
                        },
                        {
                            type: 0,
                            value: " off and 1 year of free shipping*"
                        }
                    ],
                    values: {
                        faireDirectPercentageDiscountNumber: formattedPercentageBasedNumber
                    }
                })
            ]
        });
    }
    if (modalVariant === AppSignUpModalVariant.FACEBOOK) {
        return /*#__PURE__*/ _jsx(Typography, {
            align: align,
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "6Z5mj0",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Purchase from over "
                    },
                    {
                        type: 1,
                        value: "brandCount"
                    },
                    {
                        type: 0,
                        value: " brands on the Faire marketplace. Sign up for free!"
                    }
                ],
                values: DEPRECATED_backwardsCompatibleValues({
                    brandCount: getTotalBrandCount()
                })
            })
        });
    } else if (modalVariant === AppSignUpModalVariant.PRODUCT) {
        return /*#__PURE__*/ _jsx(Typography, {
            align: align,
            children: /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                noJS: true,
                tabletAndAbove: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "mAyXW2",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Purchase from over "
                        },
                        {
                            type: 1,
                            value: "brandCount"
                        },
                        {
                            type: 0,
                            value: " brands on Faire. Sign up for free!"
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        brandCount: getTotalBrandCount()
                    })
                }),
                mobile: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "7pI03l",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Purchase from over "
                        },
                        {
                            type: 1,
                            value: "brandCount"
                        },
                        {
                            type: 0,
                            value: " brands. Sign up for free!"
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        brandCount: getTotalBrandCount()
                    })
                })
            })
        });
    } else if (isOpenWithFaire) {
        var maxLimitAmount = formatMoney({
            money: offeredMaxTerms,
            roundingStrategy: RoundingStrategy.DROP_CENTS
        });
        return /*#__PURE__*/ _jsx(Typography, {
            align: align,
            children: /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                noJS: true,
                tabletAndAbove: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "LQTU4M",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Get up to "
                        },
                        {
                            type: 1,
                            value: "maxLimitAmount"
                        },
                        {
                            type: 0,
                            value: " in inventory from thousands of brands for your new store."
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        maxLimitAmount: maxLimitAmount
                    })
                }),
                mobile: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "GQL/5w",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Get up to "
                        },
                        {
                            type: 1,
                            value: "maxLimitAmount"
                        },
                        {
                            type: 0,
                            value: " in inventory from thousands of unique brands for your new store."
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        maxLimitAmount: maxLimitAmount
                    })
                })
            })
        });
    } else if (livestream) {
        return /*#__PURE__*/ _jsx(Typography, {
            align: align,
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "tjGOFf",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sign up to access exclusive industry livestream content!"
                    }
                ]
            })
        });
    } else if (isFaireMarket) {
        return /*#__PURE__*/ _jsx(Typography, {
            align: align,
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "CDGwKi",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sign up as a retailer on Faire to join our"
                    },
                    {
                        type: 1,
                        value: "lineBreak"
                    },
                    {
                        type: 0,
                        value: "upcoming virtual trade shows and start"
                    },
                    {
                        type: 1,
                        value: "lineBreak"
                    },
                    {
                        type: 0,
                        value: "shopping wholesale today!"
                    }
                ],
                values: DEPRECATED_backwardsCompatibleValues({
                    lineBreak: /*#__PURE__*/ _jsx("br", {})
                })
            })
        });
    } else if ((localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.FRA || (localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.DEU) {
        return /*#__PURE__*/ _jsx(Typography, {
            align: align,
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "UT7zF/",
                defaultMessage: [
                    {
                        type: 0,
                        value: "High-quality brands for your customers. The registration is free."
                    }
                ]
            })
        });
    }
    return /*#__PURE__*/ _jsx(Typography, {
        align: align,
        children: /*#__PURE__*/ _jsx(ResponsiveContentV2, {
            noJS: true,
            tabletAndAbove: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "6O7l52",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Purchase from over "
                    },
                    {
                        type: 1,
                        value: "brandCount"
                    },
                    {
                        type: 0,
                        value: " unique brands. Sign up for free!"
                    }
                ],
                values: DEPRECATED_backwardsCompatibleValues({
                    brandCount: getTotalBrandCount()
                })
            }),
            mobile: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "7pI03l",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Purchase from over "
                    },
                    {
                        type: 1,
                        value: "brandCount"
                    },
                    {
                        type: 0,
                        value: " brands. Sign up for free!"
                    }
                ],
                values: DEPRECATED_backwardsCompatibleValues({
                    brandCount: getTotalBrandCount()
                })
            })
        })
    });
};
